<div  class="rt-right-fade"> 
  <div class="right-modal-card">
   <span class="material-icons modal-close">
     close
   </span>
  </div>
 </div>